import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllMembershipsByAccountId = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/memberships`);

export const getAllProductsByMembership = (id, membershipid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/account/${id}/membership/${membershipid}/products`,
  );

export const getAllGroupsByMembership = (id, membershipid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/account/${id}/membership/${membershipid}/groups`,
  );

export const saveMembershipByAccount = (id, membership) =>
  apiClient.post(`${REST_API_BASE_URL}/account/${id}/membership`, membership);

export const getMembership = (id, membershipid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/account/${id}/membership/${membershipid}`,
  );

export const updateMembership = (id, membership) =>
  apiClient.put(`${REST_API_BASE_URL}/membership/${id}`, membership);

export const deleteMembership = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/membership/${id}`);

export const addProductByMembership = (accid, membershipid, prodid) =>
  apiClient.post(
    `${REST_API_BASE_URL}/account/${accid}/membership/${membershipid}/product/${prodid}`,
  );

export const addGroupByMembership = (accid, membershipid, groupid) =>
  apiClient.post(
    `${REST_API_BASE_URL}/account/${accid}/membership/${membershipid}/group/${groupid}`,
  );

export const removeProductFromMembership = (accid, membershipid, prodid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/account/${accid}/membership/${membershipid}/product/${prodid}`,
  );

export const removeGroupFromMembership = (accid, membershipid, groupid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/account/${accid}/membership/${membershipid}/group/${groupid}`,
  );

export default apiClient;
